import styled from 'styled-components';
import { typography } from '@signplatform-ui/typographics';

// eslint-disable-next-line import/prefer-default-export
export const StyledHeader = styled.h6`
  margin: 0 0 24px;
  ${typography['Additional/L']}
`;
